<template>
  <BaseDialog ref="confirm-dialog" heading="h2" :padding="false" />
</template>

<script>
  import BaseDialog from '~/components/base/BaseDialog.vue';
  export default {
    name: 'ProfileCompanyConfirmPrompt',
    components: {
      BaseDialog,
    },
    methods: {
      prompt() {
        return new Promise((resolve, reject) => {
          this.$refs['confirm-dialog'].prompt({
            title:
              'We noticed your account is missing an updated Company Profile.',
            message:
              '<span style="color: var(--itr-blue);">At ITR Economics, we use a unique methodology that can incorporate qualitative instances into a forecast. This provides a greater accuracy for the forecast by taking into account real-world circumstances that impact business performance. To assist in creating this higher level of accuracy, we have each client complete both a <em>Company Profile</em> (to be completed now), and a <em>Data Profile</em> (to be completed during the data upload for each individual dataset).</span>',
            message2:
              '<span style="color: var(--itr-blue);">The following form will take approximately <span class="bold">10 minutes</span> of your time.</span>',
            confirmText: 'COMPLETE NOW',
            cancelText: 'COMPLETE LATER',
            level: 'itr-green',
          });
          this.$refs['confirm-dialog'].resolvePromise = resolve;
          this.$refs['confirm-dialog'].rejectPromise = reject;
        });
      },
    },
  };
</script>
